// extracted by mini-css-extract-plugin
export default {"switchInput":"SwitchInput_switchInput__5BTio","small":"SwitchInput_small__vH9jb","switchCheckbox":"SwitchInput_switchCheckbox__MvcLT","switchLabel":"SwitchInput_switchLabel__r9UJA"};